import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actions from './actions';

const initialState = {
  error: {},
  list: [],
  success: {},
  isLoading: false,
  fetched: false,
};

const setFetchTagsRequest = (state) =>
  update(state, {
    error: { $set: {} },
    isLoading: { $set: true },
    success: { $set: {} },
    fetched: { $set: true },
  });

const setFetchTagsSuccess = (state, action) =>
  update(state, {
    isLoading: { $set: false },
    list: { $set: action.payload.list },
  });

const setFetchTagsFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    isLoading: { $set: false },
  });

const setPostTagRequest = (state) =>
  update(state, {
    error: { $set: {} },
    success: { $set: {} },
  });

const setPostTagSuccess = (state, action) =>
  update(state, {
    list: { $set: state.list.concat([action.payload.result]) },
  });

const setPostTagFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
  });

export default handleActions(
  {
    [actions.FETCH_TAGS_REQUEST]: setFetchTagsRequest,
    [actions.FETCH_TAGS_SUCCESS]: setFetchTagsSuccess,
    [actions.FETCH_TAGS_FAILURE]: setFetchTagsFailure,

    [actions.POST_TAG_REQUEST]: setPostTagRequest,
    [actions.POST_TAG_SUCCESS]: setPostTagSuccess,
    [actions.POST_TAG_FAILURE]: setPostTagFailure,
  },
  initialState,
);
